export const props = { fillRule: "evenodd", clipRule: "evenodd" };
export const path = "M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V20C24 21.1046 23.1046 22 22 22H2C0.89543 22 0 21.1046 0 20V2ZM2.40039 2.20036H10.8004V19.8004H2.40039V2.20036ZM21.5992 2.20036H13.1992V19.8004H21.5992V2.20036Z";
